import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Stack, Box } from '@mui/material';

interface CardSkeletonProps {
  showActions?: boolean;
  showImage?: boolean;
  lines?: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({
  showActions = false,
  showImage = false,
  lines = 3
}) => {
  return (
    <Card
      sx={{
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.05)',
        borderRadius: 2,
        overflow: 'hidden'
      }}
    >
      {showImage && (
        <Skeleton
          variant="rectangular"
          height={200}
          animation="wave"
        />
      )}
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Skeleton
          variant="text"
          width="60%"
          height={32}
          sx={{
            mb: 2,
            borderRadius: 1,
            width: { xs: '60%', sm: '40%' }
          }}
          animation="wave"
        />
        <Stack spacing={1.5}>
          {Array.from({ length: lines }).map((_, index) => (
            <Box key={index}>
              <Skeleton
                variant="text"
                width={index === 0 ? "90%" : index === lines - 1 ? "60%" : "100%"}
                height={20}
                sx={{ borderRadius: 0.5 }}
                animation="wave"
              />
              {index === 0 && (
                <Skeleton
                  variant="text"
                  width="70%"
                  height={16}
                  sx={{ mt: 0.5, borderRadius: 0.5 }}
                  animation="wave"
                />
              )}
            </Box>
          ))}
        </Stack>
      </CardContent>
      {showActions && (
        <CardActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 }, pt: 0, gap: 1.5, flexWrap: 'wrap' }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            sx={{
              borderRadius: 1.5,
              width: { xs: '100%', sm: 120 }
            }}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={44}
            sx={{
              borderRadius: 1.5,
              width: { xs: '100%', sm: 120 }
            }}
            animation="wave"
          />
        </CardActions>
      )}
    </Card>
  );
};

export default CardSkeleton;